import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { AppSettings } from "src/assets/config/app-settings";

@Injectable({providedIn: 'root'})
export class MessageService {
  private http = inject(HttpClient);
  private settings = inject(AppSettings);

  getThreads(number: string, userId: string, skip = 0, top = 10, view?: 'inbox' | 'archived' | 'deleted') {
    const url = `${this.settings.apiBaseUrl}/api/sms/threads`;
    const params: any = {
      number: number,
      userId: userId,
      $top: top.toString(),
      $skip: skip.toString()
    };

    if (view && view !== 'inbox') {
      params.view = view;
    }

    return this.http
      .get<ThreadsResponse>(url, { params });
  }

  getMessages(conversationId: string, skip = 0, top = 50) {
    const url = `${this.settings.apiBaseUrl}/api/sms/messages/${conversationId}?$top=${top}&$skip=${skip}`;
    return this.http.get<MessagesResponse>(url);
  }

  archiveThreads(conversationIds: string[], userId: string, customerId: string) {
    const url = `${this.settings.apiBaseUrl}/api/sms/threads/archive`;
    return this.http.post(url, { conversationIds, userId, customerId });
  }

  unarchiveThreads(conversationIds: string[], userId: string, customerId: string) {
    const url = `${this.settings.apiBaseUrl}/api/sms/threads/unarchive`;
    return this.http.post(url, { conversationIds, userId, customerId });
  }

  deleteThreads(conversationIds: string[], userId: string, customerId: string) {
    const url = `${this.settings.apiBaseUrl}/api/sms/threads/delete`;
    return this.http.post(url, { conversationIds, userId, customerId });
  }
}

export interface ThreadsResponse {
  ['@odata.count']: number,
  value: Thread[]
}

export interface Thread {
  _id: string,
  conversationId: string,
  from: string,
  to: string,
  occurred_at: Date,
  text: string,
  unreadCount?: number,
  isRead?: boolean,
  archived?: boolean,
  deleted?: boolean
}

export interface MessagesResponse {
  ['@odata.count']: number,
  value: Message[]
}

export interface Message {
  _id: string,
  from: string,
  to: string,
  text: string,
  occurred_at: Date,
  direction?: 'inbound' | 'outbound',
  media?: MediaAttachment[]
}

export interface MediaAttachment {
  url: string,
  content_type: string,
  size?: number
}


